export var UnitOfMeasurement;
(function (UnitOfMeasurement) {
    UnitOfMeasurement["M3"] = "m\u00B3";
    UnitOfMeasurement["KWH"] = "kWh";
})(UnitOfMeasurement || (UnitOfMeasurement = {}));
